export default "__VITE_ASSET__DzhO7cMS__"